import { faUser } from '@fortawesome/free-solid-svg-icons';
import React, {useState } from 'react';
import {useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch } from 'react-redux';
import { msgAccessPromt } from "../../constant/constant";
import BackButton from './BackButton';

const SignupPage = () => {
  
  const [name, setname] = useState('');
  const [email, setEmail] = useState('');
  const dispatch=useDispatch();
  const navigate = useNavigate();
  
  const handleSubmit = async (e) =>  {
            if(!name){
                msgAccessPromt({dispatch,error:true,msg:'Enter User name !!'});
                return false;
            }

    localStorage.setItem('user_email',email);
    localStorage.setItem('user_name',name);
    navigate("/M_pin");
  };
 
  
      return (
        <div className='bodyDiv' style={{marginTop:'36%'}}>
           <div style={{position:'absolute',top:'14%'}}>
            <img src="home/images/logo_tara.png" style={{maxWidth:'56%'}} />
            </div>
        <div className="signup-container">
        
    <div className="title_Form" style={{justifyContent:'space-between'}}>
                <div className="title_left">
                    <h1 className="main_title">SIGN UP</h1>
                    <p>Create your new account</p>
                    </div>
                <div className="title_right">
                    <FontAwesomeIcon icon={faUser} color="#007bff" size="3x" padding='3%' />
                    
                </div>
            </div>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faUser} color="gray" size="1x" padding='3%' /></i>
                <input className='input_lable_deep' type="text" value={name} onChange={(e)=>setname(e.target.value)} placeholder="Full name" />
            </div>
            <div className="input-group">
                <i><FontAwesomeIcon icon={faUser} color="gray" size="1x" padding='3%' /></i>
                <input className='input_lable_deep' type="email" value={email} onChange={(e)=>setEmail(e.target.value)} placeholder="email" />
            </div>
            <button className="continue-button" onClick={handleSubmit}>CONTINUE</button>
            <p className="signin-link">Have an account? <a href="javascript:void(0)" onClick={()=>navigate("/login")}>Sign In</a></p>
        </div>
        </div>
    );
};

export default SignupPage;
